/* KK mozgás réteg. Csak a kk- szekciókat animálja, a Minimog saját animációihoz nem nyúl. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;
  var root = document.documentElement;
  root.classList.add('kk-motion');

  // Mit animáljunk görgetésre (csoportonként lépcsőzetesen)
  var GROUPS = [
    '.kk-section .kk-label', '.kk-section .kk-title', '.kk-section .kk-sub', '.kk-see-all',
    '.kk-review', '.kk-xrec__card', '.kk-xrush__card', '.kk-xsteps__item', '.kk-xsteps__note',
    '.kk-products__grid > .m\\:column', '.kk-cat', '.kk-guar__item', '.kk-step', '.kk-card',
    '.kk-faq__item', '.kk-chip', '.kk-occ__title', '.kk-emo__col', '.kk-emo__title', '.kk-emo__desc',
    '.kk-finder__title', '.kk-finder__opt', '.kk-nl__box', '.kk-nl__title', '.kk-reviews__more',
    '.kk-trustbar__item', '.kk-story__body', '.kk-npick__tile', '.kk-npick__sp', '.kk-npick__ask', '.kk-formats__card', '.kk-ptiers__card',
    '.kk-story__row', '.kk-contact__card', '.kk-contact__form', '.kk-promise__card', '.kk-404__box',
    '.kk-cta-band__inner', '.kk-xcta__inner > *', '.kk-stat', '.kk-pghero__visual'
  ];

  function inScroller(el) {
    for (var a = el.parentElement, n = 0; a && n < 4; a = a.parentElement, n++) {
      var ox = getComputedStyle(a).overflowX;
      if (ox === 'auto' || ox === 'scroll') return true;
    }
    return false;
  }

  function mark(scope) {
    GROUPS.forEach(function (sel) {
      var els;
      try { els = scope.querySelectorAll(sel); } catch (e) { return; }
      els.forEach(function (el) {
        if (el.hasAttribute('data-kk-r') || el.hasAttribute('data-kk-done') || el.closest('.kk-hero__left, .kk-xhero__copy, .kk-pghero__copy')) return;
        // J-53: vízszintesen lapozható sávban nincs elemenkénti belépő (különben oldalra húzáskor úsznak be a kártyák)
        if (inScroller(el)) { el.setAttribute('data-kk-done', ''); return; }
        // A-41: az első betöltéskor a hajtás felett lévő elem azonnal látszik (nem késlelteti az LCP-t)
        if (!markedOnce && window.scrollY < 50) { var rr = el.getBoundingClientRect(); if (rr.top < window.innerHeight && rr.bottom > 0) { el.setAttribute('data-kk-done', ''); return; } }
        el.setAttribute('data-kk-r', el.getAttribute('data-kk-dir') || '');
        // lépcsőzés a testvérek között
        var i = 0, s = el;
        while ((s = s.previousElementSibling)) { if (s.matches && s.matches(sel)) i++; }
        el.style.setProperty('--kk-i', Math.min(i, 8));
      });
    });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      var el = e.target;
      el.classList.add('is-in'); io.unobserve(el);
      // a belépő után leszedjük a jelölést, hogy a hover effektek szabadon működjenek
      setTimeout(function () { el.setAttribute('data-kk-done', ''); el.removeAttribute('data-kk-r'); el.classList.remove('is-in'); }, 1900);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  var markedOnce = false;
  function observe(scope) {
    mark(scope);
    markedOnce = true;
    scope.querySelectorAll('[data-kk-r]:not(.is-in)').forEach(function (el) { io.observe(el); });
  }

  // Számláló animáció a valós statisztikákhoz (pl. 260, 4,96)
  function countUp(el) {
    var txt = el.textContent, m = txt.match(/(\d+(?:[.,]\d+)?)/);
    if (!m) return;
    var raw = m[1], dec = (raw.split(/[.,]/)[1] || '').length, sep = raw.indexOf(',') > -1 ? ',' : '.';
    var target = parseFloat(raw.replace(',', '.')), start = null, dur = 1400;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1), v = target * (1 - Math.pow(1 - p, 3));
      el.textContent = txt.replace(raw, v.toFixed(dec).replace('.', sep));
      if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
    }
    requestAnimationFrame(step);
  }
  var cio = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { countUp(e.target); cio.unobserve(e.target); } });
  }, { threshold: 0.6 });

  // Finom 3D döntés egérrel (csak valódi egeres eszközön)
  function tilt(scope) {
    if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    scope.querySelectorAll('.kk-xrush__card, .kk-guar__item, .kk-contact__card, .kk-promise__card, .kk-step').forEach(function (c) {
      if (c.classList.contains('kk-tilt')) return;
      c.classList.add('kk-tilt');
      c.addEventListener('mousemove', function (ev) {
        var r = c.getBoundingClientRect(), x = (ev.clientX - r.left) / r.width - .5, y = (ev.clientY - r.top) / r.height - .5;
        c.style.setProperty('--kk-ry', (x * 6).toFixed(2) + 'deg');
        c.style.setProperty('--kk-rx', (-y * 6).toFixed(2) + 'deg');
      });
      c.addEventListener('mouseleave', function () { c.style.setProperty('--kk-ry', '0deg'); c.style.setProperty('--kk-rx', '0deg'); });
    });
  }

  // Visszaszámláló másodperc "tick" effekt
  function ticks() {
    document.querySelectorAll('.kk-cd__num[data-u="s"]').forEach(function (n) {
      if (n.dataset.kkTick) return; n.dataset.kkTick = '1';
      new MutationObserver(function () { n.classList.remove('is-tick'); void n.offsetWidth; n.classList.add('is-tick'); })
        .observe(n, { childList: true, characterData: true, subtree: true });
    });
  }

  function init(scope) {
    scope = scope || document;
    observe(scope);
    scope.querySelectorAll('.kk-hero__value, .kk-stat__num, [data-kk-count]').forEach(function (el) { cio.observe(el); });
    tilt(scope);
    ticks();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Téma szerkesztőben újrarajzolt szekciók
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // Biztonsági háló: ha valami mégsem jelenne meg 4 mp után (pl. nyomtatás, régi böngésző)
  setTimeout(function () {
    document.querySelectorAll('[data-kk-r]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
    });
  }, 4000);
  window.addEventListener('beforeprint', function () { document.querySelectorAll('[data-kk-r]').forEach(function (el) { el.classList.add('is-in'); }); });
})();
